<section id="menu_front">
  <a class="menu_item menu_search current" href=""><img src="assets/img/icon_search.png"> <p>{{'inspector.search' | translate}}</p></a>
  <a class="menu_item menu_profile" href="profil.html"><img src="assets/img/icon_profile.png"> <p>{{'fields.profile' | translate}}</p></a>
  <a class="menu_item menu_export" href="dashboard/inspector/inspector-export"><img src="assets/img/icon_profile.png"> <p>{{'common.export' | translate}}</p></a>
  <a href="" (click)="logout_user()" class="menu_item menu_logout" ><img src="assets/img/icon_logout.png"> <p>{{'header.logout' | translate}}</p></a>
</section>
